import comp from "./components";
export default comp;
